import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/acceptable-use-policy.md?raw';

export default function AcceptableUseScreen() {
  return <LegalDoc markdown={markdown} title="Acceptable Use Policy" />;
}
